import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  IconButton,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Chip,
  Container,
  Typography,
  Stack,

} from '@mui/material';

import {
  blue,
  lightBlue,
  grey,
  blueGrey,
  teal
} from '@mui/material/colors';

import ArrowForwardTwoToneIcon from '@mui/icons-material/ArrowForwardTwoTone';

function SecondEnviromentContainer(props){
  return (
    <Box
      sx={{width:'100%', height:'50vh', position:'relative'}}>
      <Box sx={{position:'relative', width:'100%', height:'100%'}}>
        <img
          style={{
            position:'absolute',
            top:'0px', bottom:'0px', left:'0px', right:'0px', width:'100%', height:'100%',
            objectFit:'cover', filter:'brightness(40%)'
          }}
          src="/assets/images/env_back2.jpg" />
        <Box sx={{
          position:'absolute',
          top:'0px', left:'0px', right:'0px', bottom:'0px', width:'100%', height:'100%',
          background:'linear-gradient(270deg, rgba(0,0,0,0), rgba(0,0,0,1))'
        }}>
          <Container sx={{position:'relative', width:'100%' , height:'100%'}}>
          <Grid
            container
            direction="row"
            sx={{
              position:'relative', width:'100%', height:'100%',
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Stack
                direction="column"
                spacing={1}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                <Typography
                  sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:700,
                    fontSize:'16px',
                    textAlign:'left',
                    width:'100%',
                    color:lightBlue[300]
                  }}>
                  보고서 요약
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:900,
                    fontSize:'28px',
                    textAlign:'left',
                    width:'100%',
                    color:blueGrey[100]
                  }}>
                  나의 절약보고서를 작성하세요
                </Typography>
                <Box sx={{width:'100%', height:'24px'}}></Box>
                <Typography
                  sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:500,
                    fontSize:'18px',
                    textAlign:'left',
                    width:'100%',
                    color:'#eeeeee'
                  }}>
                  다끌레어 텀블러 세척기는 실시간으로 사용량을 기록합니다.
                  <br/>이를 통해 절약량에 따른 보고서를 제작합니다.
                  <br/>ENV-REPORT 서비스를 통해 최적의 보고서를 받아보세요
                </Typography>
                <Box sx={{width:'100%', height:'24px'}}></Box>
                <Typography
                  sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:500,
                    fontSize:'18px',
                    textAlign:'left',
                    width:'100%',
                    color:'#eeeeee'
                  }}>
                  <Button variant="outlined" sx={{border:'1px solid #ffffff', color:'#ffffff'}}
                    endIcon={<ArrowForwardTwoToneIcon sx={{color:'#ffffff'}}/>}>
                  보고서 미리보기
                  </Button>
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 0, sm: 0, md: 6 }}>
            </Grid>
          </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default SecondEnviromentContainer;
